import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { CopySourceAdapter, commonCopySourceAdapts } from './copysource.adapter';
import { CopyActivity } from 'app/model/pipeline/copy.activity';
import _ from 'lodash';
import { ValueAdapter } from '../../value.adapter';
import { Metamodel } from 'app/model/base/model';
import { SapHanaCopySource } from 'app/model/pipeline/copysource/saphana.copysource';
import { partitionOptionConst } from 'app/registries/consts/metadata-consts';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(SapHanaCopySource),
    asynchronous: true,
    adapts: {
        ...commonCopySourceAdapts,
        query: '*',
        packetSize: '*',
        partitionOption: '*',
        partitionSettings: {
            partitionColumnName: '*'
        }
    }
})
export class SapHanaCopySourceAdapter extends CopySourceAdapter<SapHanaCopySource, Model.SapHanaSource> {
    protected override async _toResource(copySource: SapHanaCopySource): Promise<Model.SapHanaSource> {
        const result: Model.SapHanaSource = this.getCommonCopySourceProperties(
            copySource,
            Metamodel.modelFor(SapHanaCopySource).name
        );
        if (copySource.mode === 'query') {
            result.query = ValueAdapter.toResource(copySource, SapHanaCopySource.READER_QUERY);
        }
        result.packetSize = ValueAdapter.toResource(copySource, SapHanaCopySource.PACKET_SIZE);

        result.partitionOption = ValueAdapter.toResource(copySource, SapHanaCopySource.PARTITION_OPTION);
        if (
            SapHanaCopySource.PARTITION_OPTION.templateValue(copySource) != null ||
            copySource.partitionOption === partitionOptionConst.sapHanaDynamicRange
        ) {
            result.partitionSettings = {
                partitionColumnName: ValueAdapter.toResource(copySource, SapHanaCopySource.PARTITION_COLUMN_NAME)
            };
        }
        return result;
    }

    protected override async _toModel(
        resource: Model.SapHanaSource,
        copyActivity: CopyActivity
    ): Promise<SapHanaCopySource> {
        const result = this.createCopySourceWithCommonProperties(
            SapHanaCopySource.MODEL,
            resource,
            copyActivity
        ) as SapHanaCopySource;
        if (resource.query) {
            ValueAdapter.toModel(result, SapHanaCopySource.READER_QUERY, resource.query);
            result.mode = 'query';
        }
        ValueAdapter.toModel(result, SapHanaCopySource.PACKET_SIZE, resource.packetSize);

        if (resource.partitionOption) {
            ValueAdapter.toModel(result, SapHanaCopySource.PARTITION_OPTION, resource.partitionOption);
        }
        if (resource.partitionSettings != null) {
            ValueAdapter.toModel(
                result,
                SapHanaCopySource.PARTITION_COLUMN_NAME,
                resource.partitionSettings.partitionColumnName
            );
        }

        const rawObject = {};
        _.merge(rawObject, await ValueAdapter.remainder(this.context, resource, SapHanaCopySource.MODEL));
        result.raw = JSON.stringify(rawObject);
        return result;
    }
}
